import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Slider from "react-slick";
import { browserHistory } from "react-router";
import BacktestService from "../../../../service/backtest.service";
import ContainerDimensions from "react-container-dimensions";
import ModelCard from "../model_card";
import Donut from "../../../d3Components/donut";
import CustomTableWithColors from "./customTableWithColors";
import TunersAndInput from "../common/tunersAndinput";
import SliderSettings from "../common/sliderSettings";
import debounce from "../../../common/debounce";
import RiskQuestionnaire from "./riskQuestionnaire";
import RiskRangeChart from "../../../common/riskRangeChart";
import MyClientHelper from "../../../pages/MyClients/myClientHelper";
import helper from "../helper";
import "./ModelPortfolio.style.scss";
import "../../../../../node_modules/slick-carousel/slick/slick.css";
import "../../../../../node_modules/slick-carousel/slick/slick-theme.css";

class ModelPortfolio extends Component {
  _isMounted = false;
  state = {
    defaultChecked: "",
    checkBoxSelected: 1,
    backtest_data: {},
    assetTableData: [],
    colors: [
      "#5262ad",
      // "#6372b5",
      // "#7581bd",
      // "#8691c6",
      "#97a1ce",
      "#a9b1d6",
      "#bac0de",
      "#cbd0e6",
    ],
    PieChartData: [],
    createBtnDisabled: true,
    creatingPortfolioSpinner: false,
    failedCreatingPortfolio: false,
    noScenarioIDreturned: false,
    riskQuestionareData: {},
    minRange: "",
    maxRange: "",
    idAssociatedValue: {},
  };

  componentDidMount() {
    this._isMounted = true;
    const {
      active_portfolio_id,
      backtest_data,
      myClientButtonActionType,
      optimization_params,
      risk_profile,
    } = this.props;
    this.setState({
      defaultChecked: active_portfolio_id,
      backtest_data: backtest_data,
    });

    if (
      active_portfolio_id &&
      backtest_data &&
      Object.keys(backtest_data).length > 0 &&
      backtest_data[active_portfolio_id].getPortfolioData
    ) {
      let getPortfolioData =
        backtest_data[active_portfolio_id].getPortfolioData;
      this.modifyData({ getPortfolioData });
    }

    // if its from myClient > +p start new portfolio
    // setting default portfolio based on values from it
    if (
      myClientButtonActionType === "new" &&
      optimization_params &&
      risk_profile
    ) {
      let riskScore = Math.max(
        risk_profile.riskPreferenceScore,
        risk_profile.riskCapacityScore
      );

      let _modelPortfolios = {};

      for (let ids in optimization_params) {
        console.log(ids);
        _modelPortfolios[ids.toString()] =
          optimization_params[ids]["max_vol"] * 1;
      }
      let id = MyClientHelper.getMappedID({
        score: riskScore,
        modelPortfolios: _modelPortfolios,
      });

      this.radioButtonHandler({ value: id.toString() });
    }

    // risk range
    if (
      this.props.build_modelportfolios &&
      this.props.build_modelportfolios.length > 0
    ) {
      let getRiskMinMaxRange = helper.getRiskMinMaxRange({
        modelportfolios: this.props.build_modelportfolios,
      });
      if (getRiskMinMaxRange && Object.keys(getRiskMinMaxRange).length > 0) {
        this.setState({
          // modelportfolios: this.props.build_modelportfolios,
          // scenario_short_list: this.props.scenario_short_list_symbols,
          // backtest_data: this.props.backtest_data,
          minRange: getRiskMinMaxRange["min"],
          maxRange: getRiskMinMaxRange["max"],
          idAssociatedValue: getRiskMinMaxRange["idAssociatedValue"],
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { active_portfolio_id, backtest_data } = nextProps;
    this.setState({
      backtest_data: backtest_data,
      defaultChecked: active_portfolio_id,
    });
    if (
      active_portfolio_id &&
      backtest_data &&
      Object.keys(backtest_data).length > 0 &&
      backtest_data[active_portfolio_id].getPortfolioData
    ) {
      let getPortfolioData =
        backtest_data[active_portfolio_id].getPortfolioData;
      this.modifyData({ getPortfolioData });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  modifyData = ({ getPortfolioData }) => {
    if (!getPortfolioData || getPortfolioData.length === 0) return;
    let PieData = [];
    let arrayOfDates = [];
    for (let i in getPortfolioData) {
      let line = getPortfolioData[i];

      arrayOfDates.push(line.dt);
      line.dt in PieData
        ? PieData[line.dt].push({
            fund: line.fund_asset_class_focus,
            fund_name: line.fund_name,
            allocation: line.allocation * 1,
            style: line.style,
          })
        : (PieData[line.dt] = [
            {
              fund: line.fund_asset_class_focus,
              fund_name: line.fund_name,
              allocation: line.allocation * 1,
              style: line.style,
            },
          ]);
    }

    let newPieData = [];
    let getColors = {};
    let last_date = arrayOfDates[arrayOfDates.length - 1];

    newPieData = PieData[last_date];

    let pieChartData = {};
    let { colors } = this.state;

    let unique_funds = newPieData
      .map((e) => e.fund)
      .filter((value, index, self) => self.indexOf(value) === index);

    for (let j = 0; j < unique_funds.length; j++) {
      getColors[unique_funds[j]] = colors[j];
    }
    for (let idx = 0; idx < newPieData.length; idx++) {
      let name = newPieData[idx]["fund"];
      if (name in pieChartData) {
        pieChartData[name] =
          pieChartData[name] * 1 + newPieData[idx]["allocation"];
      } else {
        pieChartData[name] = newPieData[idx]["allocation"] * 1;
      }
    }

    let piChartFinalData = [];

    for (let prop in pieChartData) {
      piChartFinalData.push({
        name: prop,
        value: pieChartData[prop],
        color: getColors[prop],
      });
    }

    let assetTableData = [];

    for (let i = 0; i < newPieData.length; i++) {
      let clr = getColors[newPieData[i]["fund"]];
      let fund_name = newPieData[i]["fund_name"];
      let allocation = newPieData[i]["allocation"];
      let arr = [clr, fund_name, allocation];
      assetTableData.push(arr);
    }

    this.setState({
      assetTableData,
      PieChartData: piChartFinalData,
    });
  };
  radioButtonHandler = ({ value }) => {
    this.setState({
      checkBoxSelected: value,
    });
    this.props.setModelPortfolioID({
      activePortfolioID: value,
      group: "model_portfolios",
    });
  };

  portfolioNameHandler = (name) => {
    const { setModelScenarioName } = this.props;

    setModelScenarioName({
      scenario_name: name,
      group: "model_portfolios",
    });

    if (name === "") {
      this.setState({
        createBtnDisabled: true,
      });
    } else {
      this.setState({
        createBtnDisabled: false,
      });
    }
  };

  finish = () => {
    const { scenario_name, active_portfolio_id } = this.props;
    let allocation_funds = {
      [active_portfolio_id]: "1",
    };

    let _options = {
      scenario_name,
      portfolio_type: "MP",
      ui_params: JSON.stringify(allocation_funds),
    };
    if (this.props.client_id) {
      _options["client_id"] = this.props.client_id;
    }
    BacktestService.createPortfolioAssetAllocations({ ..._options })
      .then((res) => {
        if (res) {
          this.setState({
            creatingPortfolioSpinner: false,
          });
          if ("scenario_id" in res && res["scenario_id"]) {
            this.setState({
              noScenarioIDreturned: false,
            });
            browserHistory.push("/portfolio/" + res.scenario_id);
          } else {
            this.setState({
              noScenarioIDreturned: true,
            });

            setTimeout(
              () =>
                this.setState({
                  noScenarioIDreturned: false,
                }),
              500
            );
          }

          this.props.resetModelPortfolio();
        }
      })
      .catch((err) => {
        console.log(err);

        this.setState({
          creatingPortfolioSpinner: false,
          failedCreatingPortfolio: true,
          noScenarioIDreturned: false,
        });

        setTimeout(
          () => this.setState({ failedCreatingPortfolio: false }),
          5000
        );
      });
  };
  createPortfolioHandler = () => {
    this.setState({
      creatingPortfolioSpinner: true,
    });

    debounce(this.finish(), 1000);
  };

  stepHandler = () => {
    if (this.props.step === 0) {
      this.props.modelPortfolioStepHandler(1);
    }
  };

  riskQuestionareDataHandler = (obj) => {
    this.setState({
      riskQuestionareData: obj,
    });
  };
  render() {
    const {
      defaultChecked,
      backtest_data,
      assetTableData,
      PieChartData,
      createBtnDisabled,
      creatingPortfolioSpinner,
      failedCreatingPortfolio,
      noScenarioIDreturned,
      // riskQuestionareData,
      minRange,
      maxRange,
      idAssociatedValue,
    } = this.state;

    const {
      scenario_name,
      active_portfolio_id,
      build_histmetrics,
      build_modelportfolios,
      direct_review_orig_scenario_id,
      direct_review_portfolio,
      setRiskQuestionnaire,
      step,
      myClientButtonActionType,
      risk_profile,
      client_name,
    } = this.props;

    // if length is lessthan 5 add empty card
    let modelPortfolioModified;

    if (build_modelportfolios && build_modelportfolios.length < 4) {
      let modified = [...build_modelportfolios];
      let obj = {
        name: "test",
        id: "",
        data: [],
      };
      modified.push(obj, obj);
      modelPortfolioModified = modified;
    } else {
      modelPortfolioModified = build_modelportfolios;
    }
    return (
      <div className="ModelPortfolio">
        {step === 0 ? (
          <RiskQuestionnaire
            stepHandler={this.stepHandler}
            // riskQuestionareDataHandler={this.riskQuestionareDataHandler}
            // setRiskQuestionnaire={setRiskQuestionnaire}
          />
        ) : (
          <Fragment>
            <div className="ModelPortfolio__cardHolder">
              {modelPortfolioModified &&
              modelPortfolioModified.length > 0 &&
              Object.keys(backtest_data).length > 0 &&
              build_histmetrics &&
              Object.keys(build_histmetrics).length > 0 ? (
                <Slider {...SliderSettings}>
                  {modelPortfolioModified.map((obj, i) => (
                    <div key={`key-${i}`}>
                      <ContainerDimensions>
                        {({ width }) => (
                          <Fragment>
                            {width > 0 ? (
                              <ModelCard
                                id={`model-portfolio-cards-${
                                  obj && obj.id ? obj.id : ""
                                }`}
                                val={obj && obj.id ? obj.id : ""}
                                width={width}
                                radioButtonHandler={this.radioButtonHandler}
                                defaultChecked={
                                  obj && obj.id && obj.id === defaultChecked
                                    ? true
                                    : false
                                }
                                disableRadioButton={
                                  (direct_review_orig_scenario_id === 0 ||
                                    direct_review_orig_scenario_id === "") &&
                                  direct_review_portfolio === false
                                    ? false
                                    : direct_review_orig_scenario_id &&
                                      direct_review_portfolio === true &&
                                      direct_review_orig_scenario_id.toString() ===
                                        obj.id
                                    ? false
                                    : true
                                }
                                headingTxt={`${
                                  obj["data"] &&
                                  obj["data"][0] &&
                                  obj["data"][0]["scenario_name"]
                                    ? obj["data"][0]["scenario_name"]
                                    : obj["data"] && obj["data"][0]
                                    ? obj["data"][0]["description"]
                                    : ""
                                }`}
                                footerTxt={"Start with this portfolio"}
                                backtest_data={backtest_data}
                                perfHistmetrics={build_histmetrics[obj.id]}
                                benchmarkName={
                                  obj["data"] &&
                                  obj["data"][0] &&
                                  obj["data"][0]["benchmark_name"]
                                    ? `${obj["data"][0]["benchmark_name"]}`
                                    : null
                                }
                                radioButtonName="modelPortfolio"
                              />
                            ) : null}
                          </Fragment>
                        )}
                      </ContainerDimensions>
                    </div>
                  ))}
                </Slider>
              ) : null}
            </div>
            {myClientButtonActionType === "new" &&
            Object.keys(risk_profile).length > 0 &&
            Object.keys(idAssociatedValue).length > 0 &&
            active_portfolio_id ? (
              <RiskRangeChart
                dualNotch={true}
                riskCapacityScore={risk_profile.riskCapacityScore}
                riskPreferenceScore={risk_profile.riskPreferenceScore}
                topNotch={true}
                min={minRange}
                max={maxRange}
                value={idAssociatedValue[active_portfolio_id]}
              />
            ) : null}
            {active_portfolio_id ? (
              <Fragment>
                <div
                  className="ModelPortfolio__donut_table_Holder container"
                  style={{ width: "100%" }}
                >
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ModelPortfolio__donut_table_Holder__donut">
                      <Donut
                        id="donut_02"
                        width={450}
                        height={450}
                        label="Asset Class"
                        data={PieChartData}
                      />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <CustomTableWithColors data={assetTableData} />
                    </div>
                  </div>
                </div>
                {active_portfolio_id && (
                  <TunersAndInput
                    scenario_name={scenario_name}
                    portfolioNameHandler={this.portfolioNameHandler}
                    btnDisabled={createBtnDisabled}
                    btnHandler={this.createPortfolioHandler}
                    displayTuners={false}
                    creatingPortfolioSpinner={creatingPortfolioSpinner}
                    failedCreatingPortfolio={failedCreatingPortfolio}
                    noScenarioIDreturned={noScenarioIDreturned}
                    client_name={client_name}
                  />
                )}
              </Fragment>
            ) : null}
          </Fragment>
        )}
      </div>
    );
  }
}

export default connect(
  ({
    buildPortfolio: {
      build_modelportfolios,
      scenario_short_list_symbols,
      model_portfolios: { active_portfolio_id, scenario_name, step },
      backtest_data,
      build_histmetrics,
      backendParams: { optimization_params },
      direct_review: {
        direct_review_orig_scenario_id,
        direct_review_portfolio,
      },
    },
    myClients: {
      client_id,
      myClientButtonActionType,
      risk_profile,
      client_name,
    },
  }) => ({
    build_modelportfolios,
    scenario_short_list_symbols,
    backtest_data,
    build_histmetrics,
    active_portfolio_id,
    scenario_name,
    optimization_params,
    direct_review_orig_scenario_id,
    direct_review_portfolio,
    step,
    client_id,
    myClientButtonActionType,
    risk_profile,
    client_name,
  }),
  (dispatch) => ({
    setModelPortfolioID: ({ activePortfolioID, group }) =>
      dispatch({
        type: "BUILD_SET_ACTIVE_PORTFOLIO",
        payload: { activePortfolioID, group },
      }),
    setModelScenarioName: ({ scenario_name, group }) =>
      dispatch({
        type: "BUILD_SET_SCENARIO_NAME",
        payload: { scenario_name, group },
      }),
    tunersHandler: ({ id, type, value }) =>
      dispatch({
        type: "COMMON_TUNERS_HANDLER",
        payload: { id, type, value },
      }),
    resetModelPortfolio: () => {
      dispatch({
        type: "RESET_BUILD_A_PORTFOLIO_MODEL_PORTFOLIO",
      });
    },
    setRiskQuestionnaire: (payload) =>
      dispatch({
        type: "BUILD_A_PORTFOLIO_SET_RISK_QUESTIONNAIRE",
        payload,
      }),
    modelPortfolioStepHandler: (payload) =>
      dispatch({
        type: "BUILD_A_PORTFOLIO_SET_MODEL_PORTFOLIO_STEP",
        payload,
      }),
  })
)(ModelPortfolio);



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/model_portfolio/ModelPortfolio.jsx